document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ryan-upsell-widget").forEach((el) => {
    const productId = el.dataset.productId;
    const body = el.querySelector(".ryan-upsell-widget__body");
    if (!body) return;

    // Replace with real upsell logic, API call, etc.
    body.innerHTML = `
      <p>Special offer for product #${productId}</p>
    `;
  });
});
